import '@formily/antd-v5';
import { env, transformUrl } from "../../utils";
import { createSchemaField } from '@formily/react';
import { forwardRef, useMemo } from 'react';
import { getHeaders } from "../../const";
import {
//////
ArrayCards, ArrayTable, BatchStorePicker, BatchUserPicker, Calculator, DatePicker, DictArrayCascader, DictCascader, DictCascaderText, DictRadio, DictSelect, DictText, FormItem, FormRangeItem, FormRender, FormSection, Help, Images, Include, Input, InputNumber, Suggest, Table, Text, Textarea, Upload, UserName, UserPicker, Link } from '@micun/form';
import { FlowLink } from "./FlowLink";
import { jsx as _jsx } from "react/jsx-runtime";
var SchemaField = createSchemaField({
  components: {
    ArrayCards: ArrayCards,
    ArrayTable: ArrayTable,
    // AdSpaces,
    // ArrayItems,
    // Attachment,
    // BenchmarkBrands,
    // Button,
    Calculator: Calculator,
    // CascadeSingle,
    // CityGroupSelect,
    // Collapse,
    // CommercialAreaSelect,
    DatePicker: DatePicker,
    // DateTag,
    DictCascader: DictCascader,
    DictCascaderText: DictCascaderText,
    DictRadio: DictRadio,
    DictSelect: DictSelect,
    DictText: DictText,
    // Flex,
    // FloorPlans,
    // Footer,
    // Form: MicunForm,
    // FormDateRange,
    FormItem: FormItem,
    FormRangeItem: FormRangeItem,
    FormSection: FormSection,
    // GeneralContractor,
    // GoLocationText,
    Help: Help,
    Images: Images,
    Include: Include,
    Input: Input,
    InputNumber: InputNumber,
    // Link,
    // ListField,
    // LocationPicker,
    // Locations,
    // LocationSelect,
    // LocationSignIn,
    // NameProgressStatus,
    // Page,
    // ProcessInformation,
    // Record,
    // Rectification,
    // RectificationFieldsList,
    // RegionSelect,
    // Section,
    // StatusFilter,
    // Sticky,
    Suggest: Suggest,
    // Switch,
    Table: Table,
    // TabsFilter,
    // Tag,
    // TaskProgress,
    Text: Text,
    Textarea: Textarea,
    Upload: Upload,
    UserName: UserName,
    UserPicker: UserPicker,
    FlowLink: FlowLink,
    BatchUserPicker: BatchUserPicker,
    BatchStorePicker: BatchStorePicker,
    DictArrayCascader: DictArrayCascader,
    Link: Link
  }
});
var Form = /*#__PURE__*/forwardRef(function (props, ref) {
  var schema = props.schema,
    options = props.options,
    components = props.components;
  var fetchOption = useMemo(function () {
    return {
      interceptors: {
        request: [function (config) {
          config = transformUrl(env, config);
          Object.assign(config.headers, getHeaders());
          return config;
        }],
        response: []
      }
    };
  }, []);
  return /*#__PURE__*/_jsx(FormRender, {
    ref: ref,
    fetchOption: fetchOption,
    options: options,
    children: /*#__PURE__*/_jsx(SchemaField, {
      schema: schema,
      components: components
    })
  });
});
export var FormilyForm = Form;